import {BiproServiceService} from "./service/api/bipro-service.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
import {IntegrationBiproVersionObjectComponent} from "./component/integration-bipro-version-object/integration-bipro-version-object.component";
import {IntegrationBiproTemplateObjectComponent} from "./component/integration-bipro-template-object/integration-bipro-template-object.component";

export const HB_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['hb.IntegrationBiproAuthType', {route: '/hb/integrationBiproAuthTypes'}],
            ['hb.IntegrationSystemBiproAuth', {route: '/hb/integrationSystemBiproAuths'}],
            ['hb.IntegrationSystemBiproShipment', {route: '/hb/integrationSystemBiproShipments'}],
            ['hb.IntegrationBiproTemplate', {route: '/hb/integrationBiproTemplates', objectComponent: [{mode: MvsCrudModeEnum.update, component: IntegrationBiproTemplateObjectComponent}]}],
            ['hb.IntegrationBiproVersion', {route: '/hb/integrationBiproVersions', objectComponent: [{mode: MvsCrudModeEnum.update, component: IntegrationBiproVersionObjectComponent}]}],

            ['hb.BiproService', {route: '/hb/biproServices', service: BiproServiceService}],
            ['hb.BiproVersion', {route: '/hb/biproVersions'}],
            ['hb.BiproPartnerAuthentication', {route: '/hb/biproPartnerAuthentications'}],
            ['hb.BiproPartner', {route: '/hb/biproPartners'}],
            ['hb.BiproFieldType', {route: '/hb/biproFieldTypes'}],

            ['hb.HbBiproContentType', {route: '/hb/hbBiproContentTypes'}],
            ['hb.HbBiproTransferType', {route: '/hb/hbBiproTransferTypes'}],
            ['hb.HbBiproShipment', {route: '/hb/hbBiproShipments'}],
            ['hb.HbBiproShipmentFile', {route: '/hb/hbBiproShipmentFiles'}],
            ['hb.HbBiproShipmentFileTarget', {route: '/hb/hbBiproShipmentFileTargets'}],
            ['hb.HbBiproShipmentFileTargetExecution', {route: '/hb/hbBiproShipmentFileTargetExecutions'}],
            ['hb.HbBiproServiceRunState', {route: '/hb/hbBiproServiceRunStates'}],

            // @ticket TM-1000001897 — BiPRO 430 inbound pipeline configuration entities (CONFIG entities).
            ['hb.HbBiproPipelineConfig', {route: '/hb/hbBiproPipelineConfigs'}],
            ['hb.HbBiproHookBinding', {route: '/hb/hbBiproHookBindings'}],

            ['hb.HbPartnerSoapConnection', {route: '/hb/hbPartnerSoapConnections'}],

            // [T1 · TAA-Trace] BiPRO 42x TAA transaction — the per-call evidence row read by the
            // "Protokoll" sub-tab of the cw case object page.
            //
            // MANDATORY: this alias was NOT registered before, although controller
            // (/mvsa/hb/biproTaaTransactions), Access and DtoDetail have existed all along. An
            // unregistered alias resolves to a null CRUD service and the widget/list path returns
            // SILENTLY EMPTY — no error, no log — which reads like a backend defect.
            ['hb.HbBiproTaaTransaction', {route: '/hb/biproTaaTransactions'}],

        ] as EntityServiceEntry[],
        multi: true
    }
];
